/**
 * Atlas-specific token overrides (doc 147 §8.9.3).
 *
 * Atlas is an internal power-tool — engineers and designers in long sessions,
 * dense screens, keyboard-first. The DS v2 customer-app defaults are tuned for
 * consumers; Atlas overrides ~10 tokens for power-user density without forking
 * the system.
 */
import type { TokenMap } from './tokens.js';

export const atlasOverrides: TokenMap = {
  'density-default': 'compact', // Linear/Notion feel; user-toggleable
  'fs-body': '13px', // ~7% denser body text, still > 12px minimum
  'lh-table': '1.45', // tighter — Atlas is table-heavy
  'sp-row': '9px', // denser table rows
  'motion-fast': '120ms', // power users feel defaults as slow
  'motion-std': '180ms',
};
